export default __webpack_public_path__ + "static/media/camera.80c581c0.svg";